var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-header shared-page-header"},[_c('div',{staticClass:"shared-page-header-title"},[_vm._t("title")],2),_vm._v(" "),_c('div',{staticClass:"buttons shared-page-header-actions"},[_vm._t("actions")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }